import { register } from 'svelte-intl-precompile'
export function registerAll() {
  register("en", () => import("$locales/en"))
  register("es", () => import("$locales/es"))
  register("fr", () => import("$locales/fr"))
  register("ko", () => import("$locales/ko"))
}
export const availableLocales = ["en","es","fr","ko"]